const Anchor = require("./../Anchor.jsx");

const ExtensionMention = ({ extension, link, inline, className }) => {
  const id = extension.id.toString();
  const number = "#" + extension.number.toString().trim();
  if (link) {
    const classes = lib.handle_classes(className, "item.link");
    return (
      <Anchor
        className={classes}
        href={`${standard.URL.extensions.pages}?item=${extension.id}`}
      >
        {number}
      </Anchor>
    );
  }
  if (inline) {
    return <span className={className}>{number}</span>;
  }
  return <div className={className}>{number}</div>;
};
ExtensionMention.displayName = "ExtensionMention";

module.exports = ExtensionMention;
